import * as types from './actionTypes';
import handleErrors from './handleErrors';
import getAPIPath from '../../js/modules/api-location';

export function loadImagesSuccess(images) {
  return { type: types.LOAD_IMAGES_SUCCESS, images };
}

export function loadImages(imageType) {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/image?image_type=${imageType}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then(handleErrors)
    .then(response => response.json().then((res) => {
      dispatch(loadImagesSuccess(res.data));
    }))
    .catch((error) => {
      throw (error);
    });
  };
}

export function uploadImage(image) {
  const formData = new FormData();
  formData.append('file', image);

  return function() {
    return fetch(`${getAPIPath}commandapi/image`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then(handleErrors)
    .catch((error) => {
      throw (error);
    });
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/imageActions.js